import SlideOutMenuV2 from "@components/SlideOutMenuV2";
import { useState, useEffect } from "react";
import { MultiSelectAutocomplete } from "@components/FormsV2/MultiSelectAutoComplete";
import Select2V2 from "@components/FormsV2/Select2/Select2V2";
import { TagOption } from "../../api/useListTagsForAccount";
import { ServiceOption } from "../../api/useListServicesForAccount";
import "./style.css";

export interface BlueprintFilterSelections {
  tags: TagOption[];
  service: ServiceOption | null;
}

interface BlueprintFiltersProps {
  userSelections: BlueprintFilterSelections;
  setUserSelections: (selections: BlueprintFilterSelections) => void;
  slideoutOpen: boolean;
  setSlideoutOpen: (isOpen: boolean) => void;
  filterCount: number;
  onSave: () => void;
  clearAll: boolean;
  setClearAll: (clear: boolean) => void;
  tagOptions: TagOption[];
  serviceOptions: ServiceOption[];
}

const BlueprintFilters = ({
  userSelections,
  setUserSelections,
  slideoutOpen,
  setSlideoutOpen,
  filterCount,
  onSave,
  clearAll,
  setClearAll,
  tagOptions,
  serviceOptions,
}: BlueprintFiltersProps) => {
  const [previousSelections, setPreviousSelections] =
    useState<BlueprintFilterSelections>({
      tags: [],
      service: null,
    });

  useEffect(() => {
    if (slideoutOpen) {
      setPreviousSelections(userSelections);
    }
  }, [slideoutOpen]);

  const handleCancel = () => {
    setUserSelections(previousSelections);
    setSlideoutOpen(false);
  };

  return (
    <SlideOutMenuV2
      title="Filter By"
      isOpen={slideoutOpen}
      onClose={handleCancel}
      onSave={onSave}
      onClearAll={() => {
        setClearAll(true);
        setSlideoutOpen(false);
      }}
      filterCount={filterCount}
    >
      <div className="blueprintFilters">
        <section>
          <MultiSelectAutocomplete
            label="Tags"
            id="tags"
            options={tagOptions}
            value={userSelections.tags}
            onChange={(selected) =>
              setUserSelections({
                ...userSelections,
                tags: (selected as TagOption[]) || [],
              })
            }
          />
        </section>
        <section>
          <Select2V2
            label="Service"
            options={serviceOptions}
            value={userSelections.service}
            onChange={(selected) =>
              setUserSelections({ ...userSelections, service: selected })
            }
            isClearable
            placeholder="Select a service..."
          />
        </section>
      </div>
    </SlideOutMenuV2>
  );
};

export default BlueprintFilters;
